import { render, staticRenderFns } from "./GiftDetails.vue?vue&type=template&id=88230844&scoped=true"
import script from "./GiftDetails.vue?vue&type=script&lang=js"
export * from "./GiftDetails.vue?vue&type=script&lang=js"
import style0 from "./GiftDetails.vue?vue&type=style&index=0&id=88230844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88230844",
  null
  
)

export default component.exports